import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import AuthModule from '@/store/auth';
import AppLayout from '@/layout/AppLayout.vue';
import PaymentOrder from '@/views/PaymentOrder.vue';
import { Page } from '@/enums/page.enum';
import EIRA from '@/views/E-IRA.vue';
import PartiesPage from '@/views/PartiesPage.vue';
import DirectDebitPage from '@/views/DirectDebitPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: AppLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        component: PaymentOrder,
      },
      {
        path: 'payment-order',
        name: Page.PaymentOrderPage,
        component: PaymentOrder,
      },
      {
        path: 'e-ira',
        name: Page.eIRAPage,
        component: EIRA,
      },
      {
        path: 'parties',
        name: Page.PartiesPage,
        component: PartiesPage,
      },
      {
        path: 'direct-debit',
        name: Page.DirectDebitPage,
        component: DirectDebitPage,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.requiresAuth)
    && !AuthModule.isAuthenticated
  ) {
    return next({ name: 'Login' });
  }

  return next();
});

export default router;
